import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Tabs} from 'antd';
import tListActions from 'Actions/taskManage/list';
import config from './config';

const {TabPane} = Tabs;

class TabsComponent extends Component {
  onTabChange = value => {
    const {listActions, getTableList, searchData} = this.props;

    // 设置tab的activeKey
    listActions.setTabActiveKey(value);
    // 设置查询条件
    listActions.setSearchData({...searchData, progress: parseInt(value, 10)});
    // 设置pageNum与pageSize
    listActions.setPageStatus({pageNum: 1, pageSize: 20});
    // 获取table列表数据
    getTableList({
      ...searchData,
      progress: parseInt(value, 10),
      pageNum: 1,
      pageSize: 20,
    });
  };

  render() {
    const {tabActiveKey} = this.props;

    return (
      <Tabs type="card" activeKey={tabActiveKey} onChange={this.onTabChange}>
        <TabPane tab="全部" key="-1" />
        <TabPane tab="进行中" key="1" />
        <TabPane tab="已完成" key="4" />
        <TabPane tab="已暂停" key="2" />
      </Tabs>
    );
  }
}

const mapStateToProps = ({taskManageList}) => ({
  tabActiveKey: taskManageList.tabActiveKey,
  searchData: taskManageList.searchData,
});

const mapDispatchToProps = dispatch => ({
  listActions: bindActionCreators(tListActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TabsComponent);
